import React from "react";
import GlobalStarOverlay from "elements/GlobalStarOverlay";
import bg1 from "assets/play365/images/landing/bg_1.webp";
import bg2 from "assets/play365/images/landing/bg_2.webp";
import bg3 from "assets/play365/images/landing/bg_3.webp";
import bg4 from "assets/play365/images/landing/bg_4.webp";
import bg5 from "assets/play365/images/landing/bg_5.webp";
import bg6 from "assets/play365/images/landing/bg_6.webp";

const floatingItems = [
  { src: bg1, className: "app-global-background__floatingItem--1" },
  { src: bg2, className: "app-global-background__floatingItem--2" },
  { src: bg3, className: "app-global-background__floatingItem--3" },
  { src: bg4, className: "app-global-background__floatingItem--4" },
  { src: bg5, className: "app-global-background__floatingItem--5" },
  { src: bg6, className: "app-global-background__floatingItem--6" },
];

export default function Play365GlobalBackground() {
  return (
    <div className="app-global-background" aria-hidden="true">
      <div className="app-global-background__base" />
      <div className="app-global-background__whiteDrift app-global-background__whiteDrift--a" />
      <div className="app-global-background__whiteDrift app-global-background__whiteDrift--b" />
      <div className="app-global-background__sparkles" />
      <GlobalStarOverlay />
      <div className="app-global-background__floatingItems">
        {floatingItems.map((item, index) => (
          <img
            key={item.className}
            src={item.src}
            className={`app-global-background__floatingItem ${item.className}`}
            alt=""
            loading={index < 2 ? "eager" : "lazy"}
            decoding="async"
          />
        ))}
      </div>
    </div>
  );
}
